import React from 'react';
import YearController from '../../services/data-declaration/year-controller';
import { setSchoolYear, setSchoolYearName } from '../../utils/authority';
import { toast } from 'react-toastify';

const styles = {
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999
    },
    dialog: {
        backgroundColor: '#fff',
        borderRadius: '12px',
        boxShadow: '0 10px 40px rgba(0, 0, 0, 0.3)',
        width: '100%',
        maxWidth: '450px',
        margin: '20px',
        overflow: 'hidden'
    },
    header: {
        background: 'linear-gradient(135deg, #1976d2 0%, #1565c0 100%)',
        color: '#fff',
        padding: '24px',
        textAlign: 'center'
    },
    headerIcon: {
        fontSize: '48px',
        marginBottom: '12px'
    },
    headerTitle: {
        margin: 0,
        fontSize: '22px',
        fontWeight: '600'
    },
    headerSubtitle: {
        margin: '8px 0 0',
        fontSize: '14px',
        opacity: 0.9
    },
    body: {
        padding: '24px'
    },
    label: {
        display: 'block',
        fontSize: '14px',
        fontWeight: '500',
        color: '#495057',
        marginBottom: '8px'
    },
    select: {
        width: '100%',
        height: '48px',
        borderRadius: '8px',
        border: '2px solid #e9ecef',
        padding: '0 16px',
        fontSize: '16px',
        backgroundColor: '#fff',
        cursor: 'pointer',
        transition: 'border-color 0.2s ease',
        appearance: 'none',
        backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%236c757d' d='M6 8L1 3h10z'/%3E%3C/svg%3E")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 16px center'
    },
    selectFocus: {
        borderColor: '#1976d2',
        outline: 'none'
    },
    yearOption: {
        padding: '12px',
        fontSize: '15px'
    },
    footer: {
        padding: '16px 24px 24px',
        display: 'flex',
        justifyContent: 'center'
    },
    button: {
        backgroundColor: '#1976d2',
        color: '#fff',
        border: 'none',
        padding: '14px 48px',
        borderRadius: '8px',
        fontSize: '16px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
    },
    buttonDisabled: {
        backgroundColor: '#ccc',
        cursor: 'not-allowed'
    },
    buttonHover: {
        backgroundColor: '#1565c0',
        transform: 'translateY(-1px)'
    },
    infoText: {
        fontSize: '13px',
        color: '#6c757d',
        textAlign: 'center',
        marginTop: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '6px'
    }
};

class YearSelectionDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listYears: [],
            selectedYearId: '',
            selectedYearName: '',
            isSubmitting: false,
            isHovering: false
        };
    }

    componentDidMount() {
        this.loadYears();
    }

    loadYears = () => {
        const payload = {
            pageNumber: 0,
            pageSize: 100,
            sort: "year desc"
        };

        YearController.getListYear(payload, res => {
            if (res && res.success && res.data && res.data.content) {
                const years = res.data.content;

                // Nếu không có năm học nào, thông báo cho parent component
                if (years.length === 0) {
                    if (this.props.onNoYears) {
                        this.props.onNoYears();
                    }
                    return;
                }

                this.setState({ listYears: years });

                // Lưu vào localStorage để sử dụng sau
                localStorage.setItem("ListYear", JSON.stringify(years));
            } else {
                // Nếu không lấy được danh sách (có thể do chưa có năm học), thông báo cho parent
                if (this.props.onNoYears) {
                    this.props.onNoYears();
                }
            }
        });
    };

    handleYearChange = (e) => {
        const yearId = e.target.value;
        const yearName = e.target.options[e.target.selectedIndex].text;
        this.setState({
            selectedYearId: yearId,
            selectedYearName: yearName
        });
    };

    handleSubmit = () => {
        const { selectedYearId, selectedYearName } = this.state;

        if (!selectedYearId) {
            toast.warning("Vui lòng chọn năm học");
            return;
        }

        this.setState({ isSubmitting: true });

        // Lưu vào cookies
        setSchoolYear(selectedYearId);
        setSchoolYearName(selectedYearName);

        // Reload trang để áp dụng năm học mới
        setTimeout(() => {
            window.location.reload();
        }, 300);
    };

    formatYearName = (year) => {
        if (year.summer) {
            return `Kỳ hè - ${year.year}-${parseInt(year.year) + 1}`;
        }
        return `${year.year}-${parseInt(year.year) + 1}`;
    };

    render() {
        const { listYears, selectedYearId, isSubmitting, isHovering } = this.state;

        return (
            <div style={styles.overlay}>
                <div style={styles.dialog}>
                    <div style={styles.header}>
                        <div style={styles.headerIcon}>
                            <i className="fas fa-calendar-alt"></i>
                        </div>
                        <h2 style={styles.headerTitle}>Chọn năm học</h2>
                        <p style={styles.headerSubtitle}>
                            Vui lòng chọn năm học để tiếp tục sử dụng hệ thống
                        </p>
                    </div>

                    <div style={styles.body}>
                        <label style={styles.label}>
                            <i className="fas fa-graduation-cap" style={{ marginRight: '8px' }}></i>
                            Năm học
                        </label>
                        <select
                            style={styles.select}
                            value={selectedYearId}
                            onChange={this.handleYearChange}
                        >
                            <option value="">-- Chọn năm học --</option>
                            {listYears.map(year => (
                                <option key={year.id} value={year.id}>
                                    {this.formatYearName(year)}
                                </option>
                            ))}
                        </select>

                        <div style={styles.infoText}>
                            <i className="fas fa-info-circle"></i>
                            Bạn có thể thay đổi năm học sau trong phần cài đặt
                        </div>
                    </div>

                    <div style={styles.footer}>
                        <button
                            style={{
                                ...styles.button,
                                ...((!selectedYearId || isSubmitting) ? styles.buttonDisabled : {}),
                                ...(isHovering && selectedYearId && !isSubmitting ? styles.buttonHover : {})
                            }}
                            onClick={this.handleSubmit}
                            disabled={!selectedYearId || isSubmitting}
                            onMouseEnter={() => this.setState({ isHovering: true })}
                            onMouseLeave={() => this.setState({ isHovering: false })}
                        >
                            {isSubmitting ? (
                                <>
                                    <i className="fas fa-spinner fa-spin"></i>
                                    Đang xử lý...
                                </>
                            ) : (
                                <>
                                    <i className="fas fa-check"></i>
                                    Xác nhận
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}

export default YearSelectionDialog;
